<div class="container-fluid">
  <div class="row">
    <app-display-counts-widget
      [widgetPanelCounts]="widgetPanelCounts"
      [title]="'Vendor Suspensions'"
    ></app-display-counts-widget>
  </div>
</div>
